import crud from './_crud'
import { callApi } from 'utils/api'
import Swal from 'sweetalert2'
import i18next from 'i18next'
const t = (key) => i18next.t(key)

const entity = 'cfdi'
const messageEntity = 'la factura'
const messagePluralEntity = 'las facturas'

const getSatCatalog = (name) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/${entity}/sat_catalogs/${name}`, {
      method: 'GET',
      headers: {
        Authorization: state.app.user.token,
      },
    })

    dispatch({
      type: 'LOAD_SAT_CATALOG',
      payload: {
        name,
        catalog: res.body
      },
    })

    return res.body
  }
}

const loadSatCatalogs = (names) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/${entity}/sat_catalogs/names`, {
      method: 'POST',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify({ names }),
    })

    dispatch({
      type: 'LOAD_SAT_CATALOGS',
      payload: res.body,
    })

    return res.body
  }
}

const getAllSatCatalogs = () => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/${entity}/sat_catalogs`, {
      method: 'GET',
      headers: {
        Authorization: state.app.user.token,
      },
    })

    return res.body
  }
}

const searchFromSatCatalog = (item) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/${entity}/sat_catalogs/search`, {
      method: 'POST',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify(item),
    })

    dispatch({
      type: 'ADD_SAT_CATALOG',
      payload: {
        name: item.name,
        item: res.body,
      },
    })

    return res.body
  }
}

const getFromSatCatalog = (item) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/${entity}/sat_catalogs/get_value`, {
      method: 'POST',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify(item),
    })

    dispatch({
      type: 'ADD_SAT_CATALOG',
      payload: {
        name: item.name,
        item: [res.body],
      },
    })

    return res.body
  }
}

const getConsecutiveFolios = () => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/${entity}/consecutive_folios`, {
      method: 'GET',
      headers: {
        Authorization: state.app.user.token,
      },
    })

    return res.body
  }
}

const stampInvoice = (item) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/${entity}/stamp_invoice`, {
      method: 'POST',
      shouldSkipStatusError: true,
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify(item),
    })

    if (res.status !== 200) {
      const backendMessage = res.body?.error || res.body?.message

      throw {
        message: backendMessage || 'No se pudo timbrar la factura',
        status: res.status,
        body: res.body,
      }
    }

    return res.body
  }
}

const getCfdiData = (filters = {}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const queryParams = new URLSearchParams();

    if (filters.client_id) {
      queryParams.append('client_id', filters.client_id);
    } else {
      if (filters.rfc) queryParams.append('rfc', filters.rfc);
      if (filters.clientName) queryParams.append('clientName', filters.clientName);
      if (filters.clientBusinessName) queryParams.append('clientBusinessName', filters.clientBusinessName);
    }

    if (filters.serie) queryParams.append('serie', filters.serie);
    if (filters.payment_status) queryParams.append('paymentStatus', filters.payment_status);
    if (filters.folio) queryParams.append('folio', filters.folio);
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.dateFrom) queryParams.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) queryParams.append('dateTo', filters.dateTo);

    const res = await callApi(`/${entity}/get_cfdi_data?${queryParams.toString()}`, {
      method: 'GET',
      headers: {
        Authorization: state.app.user.token,
      },
    });

    return res.body;
  };
};



const getClients = () => {
  return async (dispatch, getState) => {
    const state = getState();

    const res = await callApi(`/${entity}/get_clients`, {
      method: 'GET',
      headers: {
        Authorization: state.app.user.token
      },
    })

    return res.body
  }
}

const sendInvoiceEmail = (data) => {
  return async (dispatch, getState) => {
    const state = getState()

    try {
      const res = await callApi(`/${entity}/send_invoice`, {
        method: 'POST',
        headers: {
          Authorization: state.app.user.token,
        },
        body: JSON.stringify(data),
      })

      Swal.fire({
        title: t('¡Acción Realizada!'),
        text: t('La factura se envió correctamente al cliente.'),
        icon: 'success',
        confirmButtonText: t('OK'),
        showCloseButton: true,
      })

      return res.body
    } catch (error) {
      Swal.fire({
        title: t('¡Error!'),
        text: t('Ocurrió un problema al enviar el correo. Verifica los datos o intenta más tarde.'),
        icon: 'error',
        confirmButtonText: t('OK'),
        showCloseButton: true,
      })
      console.error('Error al enviar la factura por correo:', error)
      throw error
    }
  }
}

const proxyDownload = (selectedInvoices, type = 'pdf') => {
  return async (dispatch, getState) => {
    const state = getState();

    const files = selectedInvoices
      .filter(inv => (type === 'pdf' ? inv?.file_pdf : inv?.file_xml))
      .map(inv => {
        const url = type === 'pdf' ? inv.file_pdf : inv.file_xml;
        const name = url.split('/').pop() || `archivo_desconocido.${type}`;
        return { url, name };
      });


    if (files.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: t('Sin archivos para descargar'),
        text: t('Ninguno de los registros seleccionados contiene archivos disponibles.'),
        confirmButtonText: t('OK'),
        showCloseButton: true,
      });
      return;
    }

    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';

    try {
      const response = await fetch(`${baseUrl}/${entity}/proxy_download`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: state.app.user.token,
        },
        body: JSON.stringify({ files }),
      });

      if (!response.ok) {
        throw new Error('Error al generar ZIP desde el servidor.');
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `Facturas_${type.toUpperCase()}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error al descargar ZIP:', error);
      Swal.fire({
        icon: 'error',
        title: t('Error'),
        text: t('No se pudo generar o descargar el archivo ZIP.'),
        confirmButtonText: t('OK'),
        showCloseButton: true,
      });
    }
  };
};

const createPayment = (item) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/${entity}/create_payment`, {
      method: 'POST',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify(item),
    })

    return res.body
  }
}

const deleteInvoice = (invoiceId) => {
  return async (dispatch, getState) => {
    const state = getState();

    const res = await callApi(`/cfdi/delete_invoice/${invoiceId}`, {
      method: 'DELETE',
      headers: {
        Authorization: state.app.user.token,
      },
      // successMessage: 'Factura eliminada correctamente.',
    });

    Swal.fire({
      title: t('¡Acción Realizada!'),
      text: t('Factura eliminada correctamente.'),
      icon: 'success',
      confirmButtonText: t('OK'),
      showCloseButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload()
      }
    })

    return res.body;
  };
};

const deleteMultipleInvoices = (invoiceIds) => {
  return async (dispatch, getState) => {
    const state = getState();

    const res = await callApi(`/cfdi/delete_multiple_invoices`, {
      method: 'DELETE',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify({ ids: invoiceIds }),
    });

    Swal.fire({
      title: t('¡Acción Realizada!'),
      text: t('Facturas eliminadas correctamente.'),
      icon: 'success',
      confirmButtonText: t('OK'),
      showCloseButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload()
      }
    })

    return res.body;
  };
};


const cancelInvoice = (invoiceId, cancelReason, replacementFolio) => {
  return async (dispatch, getState) => {
    const state = getState();

    const res = await callApi(`/cfdi/cancel_invoice/${invoiceId}`, {
      method: 'PUT',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify({
        cancel_reason: cancelReason,
        folio_replaces_voucher: replacementFolio,
      }),
    });

    Swal.fire({
      title: t('¡Acción Realizada!'),
      text: t('La factura ha sido cancelada correctamente.'),
      icon: 'success',
      confirmButtonText: t('OK'),
      showCloseButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });

    return res.body;
  };
};


const cancelMultipleInvoices = (invoiceIds, cancelReason) => {
  return async (dispatch, getState) => {
    const state = getState();

    const res = await callApi(`/cfdi/cancel_multiple_invoices`, {
      method: 'PUT',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify({
        ids: invoiceIds,
        cancel_reason: cancelReason,
      }),
    });

    Swal.fire({
      title: t('¡Acción Realizada!'),
      text: t('Las facturas seleccionadas han sido canceladas correctamente.'),
      icon: 'success',
      confirmButtonText: t('OK'),
      showCloseButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });

    return res.body;
  };
};

const getCfdiPaymentData = (filters = {}) => {
  return async (dispatch, getState) => {
    const state = getState();

    const queryParams = new URLSearchParams();

    if (filters.client_id) {
      queryParams.append('client_id', filters.client_id);
    } else {
      if (filters.rfc) queryParams.append('rfc', filters.rfc);
      if (filters.clientName) queryParams.append('clientName', filters.clientName);
      if (filters.clientBusinessName) queryParams.append('clientBusinessName', filters.clientBusinessName);
    }

    if (filters.serie) queryParams.append('serie', filters.serie);
    if (filters.payment_status) queryParams.append('payment_status', filters.payment_status);
    if (filters.folio) queryParams.append('folio', filters.folio);
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.dateFrom) queryParams.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) queryParams.append('dateTo', filters.dateTo);

    const res = await callApi(`/${entity}/get_cfdi_payment_data?${queryParams.toString()}`, {
      method: 'GET',
      headers: {
        Authorization: state.app.user.token
      },
    });

    return res.body;
  };
};

const deleteInvoicePayment = (invoiceId) => {
  return async (dispatch, getState) => {
    const state = getState();

    const res = await callApi(`/cfdi/delete_invoice_payment/${invoiceId}`, {
      method: 'DELETE',
      headers: {
        Authorization: state.app.user.token,
      },

    });

    Swal.fire({
      title: t('¡Acción Realizada!'),
      text: t('Pago de Factura eliminado correctamente.'),
      icon: 'success',
      confirmButtonText: t('OK'),
      showCloseButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload()
      }
    })

    return res.body;
  };
};

const deleteMultipleInvoicesPayment = (invoiceIds) => {
  return async (dispatch, getState) => {
    const state = getState();

    const res = await callApi(`/cfdi/delete_multiple_invoices_payment`, {
      method: 'DELETE',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify({ ids: invoiceIds }),
    });

    Swal.fire({
      title: t('¡Acción Realizada!'),
      text: t('Pagos de Facturas eliminados correctamente.'),
      icon: 'success',
      confirmButtonText: t('OK'),
      showCloseButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload()
      }
    })

    return res.body;
  };
};

const cancelInvoicePayment = (invoiceId, cancelReason, replacementFolio) => {
  return async (dispatch, getState) => {
    const state = getState();

    const res = await callApi(`/cfdi/cancel_invoice_payment/${invoiceId}`, {
      method: 'PUT',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify({
        cancel_reason: cancelReason,
        folio_replaces_voucher: replacementFolio,
      }),
    });

    Swal.fire({
      title: t('¡Acción Realizada!'),
      text: t('El pago de la factura ha sido cancelado correctamente.'),
      icon: 'success',
      confirmButtonText: t('OK'),
      showCloseButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });

    return res.body;
  };
};


const cancelMultipleInvoicesPayment = (invoiceIds, cancelReason) => {
  return async (dispatch, getState) => {
    const state = getState();

    const res = await callApi(`/cfdi/cancel_multiple_invoices_payment`, {
      method: 'PUT',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify({
        ids: invoiceIds,
        cancel_reason: cancelReason,
      }),
    });

    Swal.fire({
      title: t('¡Acción Realizada!'),
      text: t('Los pagos de las facturas seleccionadas han sido cancelados correctamente.'),
      icon: 'success',
      confirmButtonText: t('OK'),
      showCloseButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });

    return res.body;
  };
};

const createInvoice = (item) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/cfdi/create_invoice`, {
      method: 'POST',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify(item),

    })

    return res.body
  }
}

const generateInvoicePdf = (id) => {
  return async (dispatch, getState) => {
    const state = getState()

    try {
      const res = await callApi(`/utils/generate_invoice_pdf/${id}`, {
        method: 'GET',
        json: false,
        json_response: false,
        headers: {
          Authorization: state.app.user.token,
        },
      })

      const blob = new Blob([await res.body.arrayBuffer()], { type: 'application/pdf' })
      const blobUrl = window.URL.createObjectURL(blob)

      return blobUrl
    } catch (error) {
      console.error('Error al generar PDF de factura:', error)
      Swal.fire({
        icon: 'error',
        title: t('Error'),
        text: t('No se pudo generar el PDF de la factura.'),
        confirmButtonText: t('OK'),
        showCloseButton: true,
      })
    }
  }
}

const getInvoicePdfUrl = (id) => {
  return async (dispatch, getState) => {
    const state = getState()
    try {
      const res = await callApi(`/utils/generate_invoice_pdf/${id}`, {
        method: 'GET',
        json: false,
        json_response: false,
        headers: {
          Authorization: state.app.user.token,
        },
      })

      const blob = new Blob([await res.body.arrayBuffer()], { type: 'application/pdf' })
      const blobUrl = window.URL.createObjectURL(blob)
      return blobUrl
    } catch (error) {
      console.error('Error al generar PDF de factura:', error)
      Swal.fire({
        icon: 'error',
        title: t('Error'),
        text: t('No se pudo generar el PDF de la factura.'),
        confirmButtonText: t('OK'),
        showCloseButton: true,
      })
      return null
    }
  }
}

const getArticlesFromQuotes = (ids) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/quote_article/get_articles_from_quotes`, {
      method: 'POST',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify({ ids }),
    })

    return res.body
  }
}

const getArticlesFromProformas = (ids) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/proforma_article/get_articles_from_proformas`, {
      method: 'POST',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify({ ids }),
    })

    return res.body
  }
}

const actions = {
  ...crud(entity, messageEntity, messagePluralEntity),
  getSatCatalog,
  loadSatCatalogs,
  getAllSatCatalogs,
  searchFromSatCatalog,
  getFromSatCatalog,
  getConsecutiveFolios,
  stampInvoice,
  getCfdiData,
  getClients,
  sendInvoiceEmail,
  proxyDownload,
  createPayment,
  deleteInvoice,
  deleteMultipleInvoices,
  cancelInvoice,
  cancelMultipleInvoices,
  getCfdiPaymentData,
  cancelInvoicePayment,
  cancelMultipleInvoicesPayment,
  deleteInvoicePayment,
  deleteMultipleInvoicesPayment,
  createInvoice,
  generateInvoicePdf,
  getInvoicePdfUrl,
  getArticlesFromQuotes,
  getArticlesFromProformas,
}

export default actions
